<template>
  <div>
    <h1>Student Grade</h1>

    <table class="table">
      <caption>
        Students who passed:
        {{
          passStudents.length
        }}
      </caption>
      <thead>
        <tr>
          <td>Name</td>
          <td>Course Score</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in passStudents" :key="student.id">
          <td>{{ student.studentName }}</td>
          <td>{{ student.courseScore }}</td>
        </tr>
      </tbody>
    </table>
    <br /><br />
    <table class="table">
      <caption>
        Students who failed:
        {{
          failStudents.length
        }}
      </caption>
      <thead>
        <tr>
          <td>Name</td>
          <td>Course Score</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="student in failStudents" :key="student.id">
          <td>{{ student.studentName }}</td>
          <td>{{ student.courseScore }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      students: [
        { studentName: "John", courseScore: 70 },
        { studentName: "Mike", courseScore: 30 },
        { studentName: "Mary", courseScore: 37 },
        { studentName: "Anna", courseScore: 63 },
        { studentName: "Mark", courseScore: 93 }
      ]
    };
  },
  mounted() {},
  computed: {
    passStudents: function() {
      return this.students.filter(s => s.courseScore >= 40);
    },
    failStudents: function() {
      return this.students.filter(s => s.courseScore < 40);
    }
  }
};
</script>
